import React from 'react'

// Components
import TextInput from 'components/input/TextInput'

// Data
import { study_reasons } from 'utils/constants/data'

function StudyReason({
    values,
    errors,
    touched,
    setFieldValue,
    handleChange,
    handleBlur,
}) {

    return (
        <div className='bg-white rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6'>
            <p className='uppercase text-xl sm:text-2xl mb-2 md:mb-4 font-bold'>Study Reasons</p>
            <hr className='h-1 border-none text-[#333] bg-[#333]' />
            <p className='uppercase text-lg sm:text-xl xl:text-2xl mb-2 md:mb-4 font-bold'>19. Of the following categories, select the one which best describes the main reason you are undertaking this course/traineeship/apprenticeship?</p>
            <div className='flex flex-col space-y-4'>
                {study_reasons.map((reason, i) => {
                    return (
                        <div className='flex flex-row items-center space-x-3'>
                            <div>
                                <input
                                    checked={values.study_reason === reason.title}
                                    id={`study-reason-option-radio-btn-${i}`}
                                    name={`study-reason-option-${i}`}
                                    type="radio"
                                    onChange={() => setFieldValue(`study_reason`, reason.title)}
                                    value={values.study_reason}
                                    className="mt-1 w-4 h-4 md:w-6 md:h-6 text-blue-600 bg-white border-gray-300 peer-checked:bg-sky-600"
                                />
                            </div>
                            <p className='text-base xl:text-lg' key={i}>{reason.title}</p>
                        </div>
                    )
                })}
            </div>
            {(errors?.study_reason && touched?.study_reason) && errors.study_reason && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{errors.study_reason}</p>
            )}
        </div>
    )
}

export default StudyReason